if (!customElements.get('swiper-carousel')) {
  class Carousel extends HTMLElement {
    constructor() {
      super();

      this.showPagination = this.dataset.pagination === 'true' ? {
        clickable: true,
        el: '[data-pagination]',
        type: 'bullets',
        bulletActiveClass: `${this.dataset.bulletActiveClass} swiper-pagination-bullet-active` || 'swiper-pagination-bullet-active',
        bulletClass: `${this.dataset.bulletClass} swiper-pagination-bullet` || 'swiper-pagination-bullet',
        dynamicBullets: this.dataset.dynamicBullets === 'true' ?? false,
      } : false;

      this.width = Number(this.dataset.width) || null;
      this.scrollbar = this.dataset.scrollbar === 'true' ? {
        el: '[data-scrollbar]',
        draggable: false,
      } : false;
    }

    connectedCallback() {
      if (window.Swiper) {
        this.init();
        this.addResizeListener();
        return;
      }
      document.addEventListener('load', (e) => {
        if (!e.target.closest('[data-swiper-script]')) return;
        
        this.init()
        this.addResizeListener();
      }); 
    }
  
    addResizeListener() {
      window.addEventListener('resize', debounce(() => {
        if (!this.classList.contains('swiper-initialized')) return;
        this.reinit();
      }), 1000);
    }

    reinit() {
      this.slider.destroy();
      this.init();
    }
    
    init() {
      const options = {
        slidesOffsetAfter: Number(this.dataset.mobileSlidesOffsetAfter) || 0,
        slidesOffsetBefore: Number(this.dataset.mobileSlidesOffsetAfter) || 0,
        touchMoveStopPropagation: true,
        touchStartForcePreventDefault: true,
        grabCursor: true,
        autoplay: this.dataset.autoplay == 'true' ? { delay: this.dataset.delay || 3000} : false,
        initialSlide: this.dataset.initialSlide || 0,
        pagination: this.showPagination,
        scrollbar: this.scrollbar,
        spaceBetween: Number(this.dataset.spaceBetween) || 2,
        preventClicksPropagation: true,
        loop: this.dataset.loop === 'true' ? true : false,
        rewind: this.dataset.rewind === 'true' ? true : false,
        width: this.width || this.parentElement?.offsetWidth,
        slidesPerView: Number(this.dataset.slidesPerViewMobile) || 1,
        slidesPerGroup: Number(this.dataset.slidesPerScrollMobile) || 1,
        initialSlide: Number(this.dataset.initialSlide) || 0,
        centeredSlides: !!this.dataset.centered,
        centeredSlidesBounds: !!this.dataset.centered,
        centerInsufficientSlides: !!this.dataset.centered,
        allowTouchMove: this.dataset.allowTouchMove === 'false' ? false : true,
        draggable: true, 
        threshold: this.dataset.threshold || 5,
        navigation: {
          nextEl: this.querySelector('[data-next]'),
          prevEl: this.querySelector('[data-prev]'),
        },
        breakpoints: {
          // when window width is >= 768px
          425: {
            slidesOffsetAfter: Number(this.dataset.slidesOffsetAfter) || 0,
            slidesOffsetBefore: Number(this.dataset.slidesOffsetAfter) || 0,
            slidesPerView: Number(this.dataset.slidesPerViewMedium) || Number(this.dataset.slidesPerViewMobile) || 1,
            slidesPerGroup: Number(this.dataset.slidesPerScroll) || 1,
          },
          768: {
            slidesOffsetAfter: Number(this.dataset.slidesOffsetAfter) || 0,
            slidesOffsetBefore: Number(this.dataset.slidesOffsetAfter) || 0,
            slidesPerView: Number(this.dataset.slidesPerView) || 1,
            slidesPerGroup: Number(this.dataset.slidesPerScroll) || 1,
          },
          1050: {
            slidesOffsetAfter: Number(this.dataset.slidesOffsetAfter) || 0,
            slidesOffsetBefore: Number(this.dataset.slidesOffsetAfter) || 0,
            slidesPerView: Number(this.dataset.slidesPerViewLarge) || Number(this.dataset.slidesPerView) || 1,
            slidesPerGroup: Number(this.dataset.slidesPerScroll) || 1,
          }
        }
      };
    
      this.slider = new Swiper(this, options);
      
      window.addEventListener('coco-shuffle:product-updated', () => {
        if (this.querySelector('[data-product-images]')) {
          this.slider.update();
        }
      })
    }
  }
  customElements.define('swiper-carousel', Carousel);
}

/*
  EXAMPLE USAGE
  *
  Be sure to inlude the classes "swiper-wrapper" around all the slides and "swiper-slide" on each slide.
  Swiper uses these internally.
  *
  *
  *
  *
  <swiper-carousel
    data-space-between="0"
    data-slides-per-view="1"
    data-centered="true"
    data-centered-bounds="true"
    class=""
  >
    <div class="swiper-wrapper">
      {% for block in section.blocks %}
        <div class="swiper-slide">
            ..slide content
        </div>
      {% endfor %}
    </div>
  </swiper-carousel>
*/